// Imports
import parentUntil from '@utilities/parentUntil';

// Constants
const JS_HOOK_SWATCH = '[js-hook-swatch]';

class Swatch {
  constructor() {
    Swatch.updateProductTile();
  }

  static updateProductTile() {
    const swatchesButtons = [...document.querySelectorAll(JS_HOOK_SWATCH)];

    if (swatchesButtons) {
      swatchesButtons.forEach((swatch) => {
        swatch.addEventListener('click', () => {
          const productTileContainer = parentUntil(swatch, '.c-product-tile');

          if (productTileContainer) {
            const productTileSwatchesButtons = [...productTileContainer.querySelectorAll(JS_HOOK_SWATCH)];
            const productTileAnchores = productTileContainer.querySelectorAll('.product-tile__anchor');
            const productTileImage = productTileContainer.querySelector('.product-tile__image img');
            const { tileUrl } = swatch.dataset;
            const { tileImage } = swatch.dataset;
            const { tileSrcSet } = swatch.dataset;

            if (productTileSwatchesButtons && productTileAnchores && tileUrl && productTileImage && tileImage && tileSrcSet) {
              productTileAnchores.forEach((el) => {el.href = tileUrl});
              productTileImage.src = tileImage;
              productTileImage.srcset = tileSrcSet;
              productTileSwatchesButtons.forEach((el) => {
                if (el) el.classList.remove('product-tile-swatch--selected');
              });
              swatch.classList.add('product-tile-swatch--selected');
            }
          }
        });
      });
    }
  }
}

export default Swatch;
